import React, { Component } from 'react';
import { connect } from 'react-redux';
import SelectInput from './SelectInput';
import LOOKUP from 'constants/lookup';

class CountryRegions extends Component {
    render() {
        const p = this.props;
        const countries = LOOKUP.common.country.options;
        if (!countries) return null;
        const countryRegions = LOOKUP.common.country.regions.filter(c => c.code == p.selectedCountry);

        return (
            <div className="row">
                <div className="col-lg-12">
                    <SelectInput
                        name={p.name + "Country"}
                        value="CA"
                        fullWidth={true}
                        label={LOOKUP.common.country.label}
                        floatingLabelText={LOOKUP.common.country.label}
                        hintText={LOOKUP.common.country.hintText}
                        options={countries} required />
                </div>
                <div className="col-lg-12">
                    <SelectInput
                        name={p.name + "State"}
                        value="BC" fullWidth={true}
                        label={LOOKUP.common.state.label}
                        floatingLabelText={LOOKUP.common.state.label}
                        hintText={LOOKUP.common.state.hintText}
                        options={countryRegions} required />
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state, props) => {
    return {
        selectedCountry: state.form[props.name + 'Country'],
        selectedRegions: state.form[props.name + 'State']
    };
};

export default connect(mapStateToProps)(CountryRegions);